import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  testimonials: localStorage.getItem('testimonials') && JSON.parse(localStorage.getItem('testimonials'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/testimonials/index.js